export default __webpack_public_path__ + "static/media/6.560fd440.png";